export const PERMISSION_DENIED_CODE = 'PERMISSION_DENIED';
export const PERMISSION_DENIED_MESSAGE = 'permissionDenied';
export const PERMISSION_DENIED_STATUS = 403;

export function isPermissionDeniedError(error) {
  if (!error) return false;

  const status = error?.response?.status ?? error?.status;
  const errorCode = error?.errorCode ?? error?.response?.data?.errorCode;
  const message = error?.message ?? error?.response?.data?.message;

  return (
    status === PERMISSION_DENIED_STATUS ||
    errorCode === PERMISSION_DENIED_CODE ||
    message === PERMISSION_DENIED_MESSAGE
  );
}
